module.exports = __webpack_public_path__ + "static/acamica.8d188cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/acamica.png
// module id = 620
// module chunks = 35783957827783